"use client";

import styled from "styled-components";

interface BoxColumnsProps {
  $columns: number;
  $marginB: string;
  $align?: string;
  $justify?: string;
  $gap?: string;
}

export const BoxColumns = styled.div<BoxColumnsProps>`
  display: grid;
  gap: 0.75rem;
  width: 100%;
  max-width: 100%;
  margin-bottom: ${({ $marginB }) => ($marginB ? $marginB : `0`)};

  gap: ${({ $gap }) => $gap || "0.75rem"};
  align-items: ${({ $align }) => $align || "start"};
  justify-items: ${({ $justify }) => $justify || "start"};

  @media (min-width: 768px) {
    gap: ${({ $gap }) => $gap || "1rem"};
  }

  ${({ $columns }) =>
    $columns === 2
      ? `
    grid-template-columns: 1fr;
    @media (min-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }`
      : $columns === 3
        ? `
    grid-template-columns: 1fr;

    @media (min-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }
  `
        : $columns === 4
          ? `
    grid-template-columns: 1fr;

    @media (min-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1200px) {
      grid-template-columns: repeat(4, 1fr);
    }
  `
          : `
    grid-template-columns: 1fr;
  `}
`;
